module.exports = __webpack_public_path__ + "static/media/quit-bg.25e7a342.png";